import { PiTruck } from 'react-icons/pi';
import { Button } from '@v2/design-system';
import V2Modal from '@v2/components/ui/V2Modal';
import PloomesDealImportPreviewPanel from './PloomesDealImportPreviewPanel';

type Props = {
    open: boolean;
    selectedIds: number[];
    loading: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export default function PloomesDealImportConfirmModal({
    open,
    selectedIds,
    loading,
    onClose,
    onConfirm,
}: Props) {
    return (
        <V2Modal
            open={open}
            onClose={onClose}
            title="Criar processos de importação?"
            description="Confira fornecedores, pedidos e clientes antes de confirmar. Será criado 1 embarque por fornecedor."
            size="5xl"
            footer={
                <>
                    <Button variant="outline" onClick={onClose} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={onConfirm}
                        isLoading={loading}
                        disabled={selectedIds.length === 0}
                        className="bg-emerald-600 hover:bg-emerald-700"
                    >
                        <PiTruck className="me-1.5 h-4 w-4" />
                        Confirmar criação
                    </Button>
                </>
            }
        >
            <PloomesDealImportPreviewPanel selectedIds={selectedIds} />
        </V2Modal>
    );
}
